export default __webpack_public_path__ + "static/media/BoringImg.523c4757.jpg";